let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9J8Yx")).then(() => parcelRequire('k16yv'));